/**
 * Exordium client bundle entry (browserified via quackage).
 *
 * Carries the foundation client chassis, the pict content sections the start page needs (the
 * CodeMirror markdown editor + the markdown/KaTeX renderer), and KaTeX itself. Bundling them
 * together lets browserify dedupe the shared pict framework (one pict-view), so the editor's views
 * register with the app's own pict instance, and keeps the app offline (no CDN).
 *
 * CodeMirror 6 is ESM-only (its @marijn/* deps cannot be parsed by browserify), so it is bundled
 * separately with esbuild into codemirror-modules.js, which sets window.CodeMirrorModules. This
 * file provides window.katex (KaTeX is CommonJS and bundles here fine); pict-section-content renders
 * math when window.katex is present.
 *
 * The window global (ExordiumClient) exposes the pieces the start-page client in html/index.html
 * consumes.
 */

const libFoundationClient = require('retold-application-foundation-client');
const libMarkdownEditor = require('pict-section-markdowneditor');
const libContent = require('pict-section-content');
const libKatex = require('katex');
const libExordiumSync = require('./Exordium-Sync.js');

if (typeof window !== 'undefined')
{
	window.katex = libKatex;
}

module.exports =
{
	RAF: libFoundationClient,
	MarkdownEditor: libMarkdownEditor,
	Content: libContent,
	Sync: libExordiumSync
};
